/**
 * Une seule webcam pour tout le poste de travail (caisse + préparation).
 *
 * La caméra de la balance n'était ouverte que par l'onglet Caisse
 * (`useCamera` dans POSContent). La préparation en a besoin aussi, pour
 * vérifier les fruits et légumes pesés (12/10/2026) : la partager ici évite
 * d'ouvrir le même périphérique deux fois. Effet de bord bienvenu : posé au
 * niveau du poste, le flux survit au remontage de POSContent (changement de
 * vendeur), qui le coupait.
 */
import { createContext, useContext, type ReactNode } from 'react';
import { useCamera, type UseCameraState } from '../hooks/useCamera';

const CameraContext = createContext<UseCameraState | null>(null);

export function CameraProvider({ children }: { children: ReactNode }) {
  const camera = useCamera();
  return <CameraContext.Provider value={camera}>{children}</CameraContext.Provider>;
}

/**
 * La caméra partagée du poste ; hors poste de travail (page isolée), une caméra
 * propre au composant, comme avant. L'instance de repli n'ouvre rien tant qu'on
 * ne l'a pas connectée.
 */
export function useCameraPartagee(): UseCameraState {
  const partagee = useContext(CameraContext);
  const locale = useCamera();
  return partagee ?? locale;
}
